export default {"src":"/_next/static/media/mt5-ios.77ad5bb4.svg","height":395,"width":556,"blurWidth":0,"blurHeight":0};